module.exports = __webpack_public_path__ + "static/img/lunbo1.24bbc0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lunbo1.jpg
// module id = OwrK
// module chunks = 1